import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ToastProvider } from "./Toast";
import devLogo from "../../images/developer_02.png";
import "../../css/admin.css";

const navItems = [
  { to: "/admin/dashboard", icon: "fa-solid fa-chart-line", label: "Dashboard" },
  { to: "/admin/translations", icon: "fa-solid fa-language", label: "Translations" },
  { to: "/admin/projects", icon: "fa-solid fa-folder-open", label: "Projects" },
  { to: "/admin/skills", icon: "fa-solid fa-code", label: "Skills" },
  { to: "/admin/work-history", icon: "fa-solid fa-briefcase", label: "Work History" },
  { to: "/admin/about", icon: "fa-solid fa-user-pen", label: "About / Bio" },
  { to: "/admin/cv", icon: "fa-solid fa-file-pdf", label: "Curriculum" },
  { to: "/admin/contacts", icon: "fa-solid fa-address-book", label: "Contacts" },
  { to: "/admin/certificates", icon: "fa-solid fa-certificate", label: "Certificates" },
];

const AdminLayout: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <ToastProvider>
      <div className="admin-wrapper">
        <button
          className="admin-mobile-toggle"
          onClick={() => setSidebarOpen((prev) => !prev)}
        >
          <i className={`fa-solid ${sidebarOpen ? "fa-xmark" : "fa-bars"}`} />
        </button>

        {/* Mobile backdrop */}
        <div
          className={`admin-sidebar-overlay${sidebarOpen ? " visible" : ""}`}
          onClick={closeSidebar}
        />

        <aside className={`admin-sidebar${sidebarOpen ? " open" : ""}`}>
          <div className="admin-sidebar-header">
            <img src={devLogo} alt="Logo" className="admin-sidebar-logo" />
            <div className="admin-sidebar-title">Admin Panel</div>
          </div>

          <nav className="admin-sidebar-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `admin-nav-item${isActive ? " active" : ""}`
                }
                onClick={closeSidebar}
              >
                <i className={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="admin-sidebar-footer">
            <button className="admin-logout-btn" onClick={handleLogout}>
              <i className="fa-solid fa-right-from-bracket" />
              <span>Logout</span>
            </button>
          </div>
        </aside>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </ToastProvider>
  );
};

export default AdminLayout;
